import ApiService from "./../api/ApiService";
import Urls from "./../api/Urls";
import Config from "../constants/Config";
import Supplier, { SupplierProduct } from "../models/Supplier";
import SupplierUsagePlan from "models/SupplierUsagePlan";
import SupplierFAQs from '../models/SupplierFAQs';

export function getSuppliers(params) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_LIST,
    params: params,
    parser: suppliersDataParser,
  }).get();
}

export function getSupplierAll(params) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_LIST_ALL,
    params: params,
    parser: suppliersDataAllParser,
  }).get();
}

export function getSupplierSelectList() {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_SELECT_LIST,
    parser: supplierSelectDataParser,
  }).get();
}

export function getSupplierDetail(id, language) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_DETAIL,
    endpointParams: { id },
    headers: { "accept-language": language },
    parser: (data) => new Supplier(data.data),
  }).get();
}

export function createSupplier(supplier) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_CREATE,
  }).post(supplier.export());
}

export function getSupplierDetailAddFAQs(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_DETAIL_FAQS,
        endpointParams: { id },
        parser: data => SupplierFAQs.parseDataFromResponse(data?.data),
    }).get();
}

export function createSupplierAddFAQs(supplierFAQs) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CREATE_FAQS,
    }).post(supplierFAQs);
}

export function deleteSupplierFAQs(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_DELETE_FAQS,
        endpointParams: { id },
    }).delete();
}

export function getSupplierProductDetail(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_DETAIL,
    endpointParams: { id },
    parser: (data) => new SupplierProduct(data.data),
  }).get();
}

// export function getSupplierUsagePlanDetail(id, query) {
//   return new ApiService({
//     baseURL: Config.API_TOUR,
//     endpoint: Urls.SUPPLIER_PRODUCT_USAGE_PLAN,
//     endpointParams: { id},
//     params: {...query},
//     parser: (data) => new SupplierUsagePlan(data),
//   }).get();
// }

export function getSupplierUsagePlanDetail(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_USAGE_PLAN,
    endpointParams: { id},
    parser: (data) => new SupplierUsagePlan(data),
  }).get();
}

export function updateSupplier(supplier) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_UPDATE,
  }).put(supplier.export());
}

export function deleteSupplier(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_DELETE,
    endpointParams: { id },
  }).delete();
}

export function getSupplierProducts(params) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_LIST,
    params: params,
    parser: supplierProductsDataParser,
  }).get();
}

export function searchCodeSupplierProducts(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_SEARCH_CODE,
    endpointParams: { id },
  }).get();
}

export function getAllSupplierProducts() {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_ALL,
    parser: supplierProductsAllDataParser,
  }).get();
}

export function createSupplierProduct(supplierProduct) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_CREATE,
  }).post(supplierProduct.export());
}

export function updateSupplierProduct(supplierProduct) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_UPDATE,
  }).put(supplierProduct.export());
}

export function deleteSupplierProduct(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_DELETE,
    params: { id },
  }).delete();
}

export function getSupplierProductGenerateCode(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_GENERATE,
    endpointParams: { id },
  }).get();
}

export function getSupplierProductWithCode(id) {
  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_PRODUCT_CODE,
    endpointParams: { id },
  }).get();
}

function suppliersDataParser(data = {}) {
  return {
    ...data.data,
    suppliers: (data.data.result || []).map((item) => new Supplier(item)),
  };
}
function suppliersDataAllParser(data = {}) {
  return {
    suppliers: (data.data || []).map((item) => new Supplier(item)),
  };
}
function supplierProductsDataParser(data = {}) {
  return {
    ...data.data,
    supplierProducts: (data.data.result || []).map(
      (item) => new SupplierProduct(item)
    ),
  };
}
function supplierProductsAllDataParser(data = {}) {
  return (data.data || []).map((item) => new SupplierProduct(item));
}

function supplierSelectDataParser(data = {}) {
  return {
    vehicles: (data.data.vehicles || []).map(
      (item) => new Supplier({ ...item, supplierName: item.name })
    ),
    accommodations: (data.data.accommodations || []).map(
      (item) => new Supplier({ ...item, supplierName: item.name })
    ),
    meals: (data.data.meals || []).map(
      (item) => new Supplier({ ...item, supplierName: item.name })
    ),
    activities: (data.data.activities || []).map(
      (item) => new Supplier({ ...item, supplierName: item.name })
    ),
  };
}

export function getVinwonderSites() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_VINWONDER_SITES,
    }).get();
}

export function getVinwonderTypes() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_VINWONDER_TYPES,
    }).get();
}

export function getVinwonderRefIds(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_VINWONDER_REFIDS,
        params: params
    }).get();
}

export function createSupplierTranslate(product) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_TRANSLATE_CREATE,
    }).post(product.export(true).translate());
}

export function updateSupplierTranslate(product) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_TRANSLATE_UPDATE,
    }).put(product.export(true).translate());
}

export function deleteSupplierTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}